// Shared country data for geo targeting (ISO codes match backend ads/geo.py).
// Used by the campaign creation wizard and the campaign location editor.

export const COUNTRIES = [
  ['PL', 'Polska', '🇵🇱'], ['DE', 'Niemcy', '🇩🇪'], ['AT', 'Austria', '🇦🇹'], ['CH', 'Szwajcaria', '🇨🇭'],
  ['FR', 'Francja', '🇫🇷'], ['BE', 'Belgia', '🇧🇪'], ['NL', 'Holandia', '🇳🇱'], ['LU', 'Luksemburg', '🇱🇺'],
  ['ES', 'Hiszpania', '🇪🇸'], ['IT', 'Włochy', '🇮🇹'], ['PT', 'Portugalia', '🇵🇹'], ['GB', 'Wielka Brytania', '🇬🇧'],
  ['IE', 'Irlandia', '🇮🇪'], ['US', 'Stany Zjednoczone', '🇺🇸'], ['CA', 'Kanada', '🇨🇦'], ['AU', 'Australia', '🇦🇺'],
  ['NZ', 'Nowa Zelandia', '🇳🇿'], ['SE', 'Szwecja', '🇸🇪'], ['NO', 'Norwegia', '🇳🇴'], ['DK', 'Dania', '🇩🇰'],
  ['FI', 'Finlandia', '🇫🇮'], ['CZ', 'Czechy', '🇨🇿'], ['SK', 'Słowacja', '🇸🇰'], ['HU', 'Węgry', '🇭🇺'],
  ['RO', 'Rumunia', '🇷🇴'], ['BG', 'Bułgaria', '🇧🇬'], ['HR', 'Chorwacja', '🇭🇷'], ['SI', 'Słowenia', '🇸🇮'],
  ['GR', 'Grecja', '🇬🇷'], ['LT', 'Litwa', '🇱🇹'], ['LV', 'Łotwa', '🇱🇻'], ['EE', 'Estonia', '🇪🇪'],
  ['CY', 'Cypr', '🇨🇾'], ['MT', 'Malta', '🇲🇹'], ['UA', 'Ukraina', '🇺🇦'], ['BR', 'Brazylia', '🇧🇷'],
  ['MX', 'Meksyk', '🇲🇽'], ['JP', 'Japonia', '🇯🇵'], ['AE', 'ZEA', '🇦🇪'],
];

export const COUNTRY_OPTIONS = COUNTRIES.map(([code, name, flag]) => ({ value: code, label: `${flag} ${name}` }));

export const COUNTRY_LABEL = Object.fromEntries(COUNTRIES.map(([code, name, flag]) => [code, `${flag} ${name}`]));

export const COUNTRY_GROUPS = {
  EU: ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'],
  EUROPE: ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'CH', 'NO', 'UA'],
  POPULAR: ['US', 'GB', 'DE', 'FR', 'ES', 'IT', 'NL', 'PL'],
};
